var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ContentDefinition } from './content-definition';
var StyleDefinition = (function (_super) {
    __extends(StyleDefinition, _super);
    function StyleDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleDefinition.prototype.fontSize = function (size) {
        this.content.fontSize = size;
        return this;
    };
    StyleDefinition.prototype.width = function (size) {
        this.content.width = size;
        return this;
    };
    StyleDefinition.prototype.height = function (size) {
        this.content.height = size;
        return this;
    };
    StyleDefinition.prototype.alignment = function (align) {
        this.content.alignment = align;
        return this;
    };
    StyleDefinition.prototype.bold = function () {
        this.content.bold = true;
        return this;
    };
    StyleDefinition.prototype.italics = function () {
        this.content.italics = true;
        return this;
    };
    StyleDefinition.prototype.margin = function (margin) {
        this.content.margin = margin;
        return this;
    };
    StyleDefinition.prototype.style = function (style) {
        this.content.style = style;
        return this;
    };
    StyleDefinition.prototype.color = function (color) {
        this.content.color = color;
        return this;
    };
    StyleDefinition.prototype.background = function (background) {
        this.content.background = background;
        return this;
    };
    StyleDefinition.prototype.link = function (link) {
        this.content.link = link;
        return this;
    };
    StyleDefinition.prototype.linkToPage = function (page) {
        this.content.linkToPage = page;
        return this;
    };
    StyleDefinition.prototype.noWrap = function () {
        this.content.noWrap = true;
        return this;
    };
    StyleDefinition.prototype.decoration = function (decoration) {
        this.content.decoration = decoration;
        return this;
    };
    StyleDefinition.prototype.decorationStyle = function (decorationStyle) {
        this.content.decorationStyle = decorationStyle;
        return this;
    };
    StyleDefinition.prototype.decorationColor = function (decorationColor) {
        this.content.decorationColor = decorationColor;
        return this;
    };
    StyleDefinition.prototype.fontFeatures = function (fontFeatures) {
        this.content.fontFeatures = fontFeatures;
        return this;
    };
    StyleDefinition.prototype.font = function (fontName) {
        this.content.font = fontName;
        return this;
    };
    StyleDefinition.prototype.absolutePosition = function (x, y) {
        this.content.absolutePosition = { x: x, y: y };
        return this;
    };
    StyleDefinition.prototype.relativePosition = function (x, y) {
        this.content.relativePosition = { x: x, y: y };
        return this;
    };
    return StyleDefinition;
}(ContentDefinition));
export { StyleDefinition };
